// extracted by mini-css-extract-plugin
export default {"ingredientLabel":"Gcab0f4","button":"Gb0b9da"};